import React, { useState, useEffect } from "react";
import { useKeycloak } from "../../keycloakContext";
import { Navigate, useLocation, Link } from "react-router-dom";
import { loginWithSSO } from "../../services/keycloakAuth";
import "./Login.css";
import logodapto from "../../assets/images/logo-d.png";

const Login = () => {
  const { keycloak, initialized } = useKeycloak();
  const location = useLocation();
  const redirectUrl = location.state?.from || "/";

  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [showResetModal, setShowResetModal] = useState(false);
  const [resetFormData, setResetFormData] = useState({
    username: "",
    tempPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [forgotFormData, setForgotFormData] = useState({
    username: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [forgotSuccess, setForgotSuccess] = useState("");
  const [showPassword, setShowPassword] = useState({
  login: false,
  resetTemp: false,
  resetNew: false,
  resetConfirm: false,
  forgotNew: false,
  forgotConfirm: false,
});

  useEffect(() => {
    const handleSSOCallback = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      const error = params.get('error');
      const errorDescription = params.get('error_description');
      const state = params.get('state');
      
      if (error) {
        setError(decodeURIComponent(errorDescription || 'SSO authentication failed'));
        window.history.replaceState({}, document.title, window.location.pathname);
        return;
      }

      if (!code) {
        return;
      }

      setIsLoading(true);
      
      try {
        const provider = state || 'google';
        
        // console.log(`[APP SSO] Exchanging code for tokens with provider: ${provider}`);
        // console.log(`[APP SSO] Code: ${code.substring(0, 20)}...`);
        
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/app/sso/${provider}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code, realm: 'dapto' })
        });
        
        // console.log(`[APP SSO] Response status: ${response.status}`);
        
        const data = await response.json();
        // console.log(`[APP SSO] Response data:`, data);
        
        if (!response.ok || !data.success) {
          throw new Error(data.error || 'Failed to authenticate with SSO');
        }

        localStorage.setItem('keycloakToken', data.access_token);
        localStorage.setItem('keycloakRefreshToken', data.refresh_token);
        
        keycloak.token = data.access_token;
        keycloak.refreshToken = data.refresh_token;
        keycloak.authenticated = true;

        if (data.user_id) {
          localStorage.setItem('user_id', data.user_id);
        }
        
        if (data.email) {
          localStorage.setItem('user_email', data.email);
        }

        try {
          const userProfile = await keycloak.loadUserProfile();
          const extractedTenantId = userProfile.attributes?.tenant_id 
            ? Array.isArray(userProfile.attributes.tenant_id) 
              ? userProfile.attributes.tenant_id[0] 
              : null 
            : null;

          if (extractedTenantId) {
            localStorage.setItem("tenant_id", extractedTenantId);
          }
          
          if (userProfile.username) {
            localStorage.setItem("user_id", userProfile.username);
          }
        } catch (profileError) {
          console.warn("Could not load full user profile, continuing with SSO data:", profileError);
        }

        window.history.replaceState({}, document.title, window.location.pathname);
        
        // console.log('✅ App SSO authentication successful');
        window.location.href = redirectUrl;
      } catch (err: any) {
        console.error("App SSO callback error:", err);
        setError(err.message || "Failed to complete SSO authentication");
        setIsLoading(false);
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    };

    if (initialized) {
      handleSSOCallback();
    }
  }, [initialized, keycloak, redirectUrl]);

  const handleSSOLogin = async (provider: "google" | "apple" | "microsoft") => {
    setIsLoading(true);
    setError("");
    try {
      const loginPageUrl = `${window.location.origin}/auth/login`;
      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/api/auth/app/sso/${provider}/login?redirect_uri=${encodeURIComponent(loginPageUrl)}`;
      
      window.location.href = apiUrl;
    } catch (err) {
      console.error(`${provider} SSO login error:`, err);
      setError(`Failed to sign in with ${provider}. Please try again.`);
      setIsLoading(false);
    }
  };

  //   setError("");

  //   try {
  //     const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/login`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         username: formData.email,
  //         password: formData.password,
  //       }),
  //     });

  //     let data;
  //     try {
  //       data = await response.json();
  //     } catch (parseError) {
  //       console.error('Failed to parse response:', parseError);
  //       throw new Error('Invalid response from server');
  //     }

  //     // console.log('Login response:', { status: response.status, data });

  //     if (!response.ok) {
  //       if (data.error_code === 'temporary_password_required' || 
  //           data.requires_password_reset || 
  //           (data.error && typeof data.error === 'string' && data.error.toLowerCase().includes('temporary password'))) {
  //         // console.log('Temporary password detected, showing reset modal');
  //         setIsLoading(false);
  //         setResetFormData({
  //           username: data.username || formData.email,
  //           tempPassword: formData.password,
  //           newPassword: '',
  //           confirmPassword: '',
  //         });
  //         setShowResetModal(true);
  //         return;
  //       }
        
  //       throw new Error(data.error || data.error_description || 'Authentication failed');
  //     }

  //     const tokenResponse = data;
      
  //     localStorage.setItem('keycloakToken', tokenResponse.access_token);
  //     localStorage.setItem('keycloakRefreshToken', tokenResponse.refresh_token);
      
  //     keycloak.token = tokenResponse.access_token;
  //     keycloak.refreshToken = tokenResponse.refresh_token;
  //     keycloak.authenticated = true;
      
  //     const userProfile = await keycloak.loadUserProfile();
  //     const extractedTenantId = userProfile.attributes?.tenant_id 
  //       ? Array.isArray(userProfile.attributes.tenant_id) 
  //         ? userProfile.attributes.tenant_id[0] 
  //         : null 
  //       : null;

  //     localStorage.setItem("user_id", userProfile.username ?? "");
  //     localStorage.setItem("tenant_id", extractedTenantId ?? "");
      
  //     window.location.href = redirectUrl;
  //   } catch (err: any) {
  //     console.error("Email sign-in error:", err);
  //     setError(err.message || "Invalid email or password");
  //     setIsLoading(false);
  //   }
  // };

  const handleEmailSignIn = async (e: React.FormEvent) => {
  e.preventDefault();
  setIsLoading(true);
  setError("");

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username: formData.email,
        password: formData.password,
      }),
    });

    // Try to parse response as JSON
    let data;
    let isJson = false;
    const contentType = response.headers.get('content-type');
    
    if (contentType && contentType.includes('application/json')) {
      try {
        data = await response.json();
        isJson = true;
      } catch (parseError) {
        console.error('Failed to parse JSON response:', parseError);
        isJson = false;
      }
    }

    

    // Handle error responses
    if (!response.ok) {
      // If we have JSON data with error information
      if (isJson && data) {
        // Check ONLY for temporary password requirement with exact error code
        if (data.error_code === 'temporary_password_required' && data.requires_password_reset === true) {
          // console.log('Temporary password detected, showing reset modal');
          setIsLoading(false);
          setResetFormData({
            username: data.username || formData.email,
            tempPassword: formData.password,
            newPassword: '',
            confirmPassword: '',
          });
          setShowResetModal(true);
          return;
        }

        // For ALL other errors, use the backend's error message
        const errorMessage = data.error || data.error_description || data.message;
        if (errorMessage) {
          setError(errorMessage);
          setIsLoading(false);
          return;
        }
      }

      // Fallback to generic messages only if no JSON data at all
      let fallbackMessage = 'Authentication failed. Please try again.';
      
      if (response.status === 401) {
        fallbackMessage = 'Invalid email or password. Please check your credentials and try again.';
      } else if (response.status === 403) {
        fallbackMessage = 'Access denied. Your account may be locked or disabled.';
      } else if (response.status >= 500) {
        fallbackMessage = 'Server error. Please try again later or contact support.';
      }
      
      setError(fallbackMessage);
      setIsLoading(false);
      return;
    }

    // Handle successful response
    if (!isJson || !data) {
      throw new Error('Invalid response format from server. Please contact support.');
    }

    // Validate required fields in success response
    if (!data.access_token || !data.refresh_token) {
      throw new Error('Invalid authentication response. Please try again.');
    }

    const tokenResponse = data;
    
    localStorage.setItem('keycloakToken', tokenResponse.access_token);
    localStorage.setItem('keycloakRefreshToken', tokenResponse.refresh_token);
    
    keycloak.token = tokenResponse.access_token;
    keycloak.refreshToken = tokenResponse.refresh_token;
    keycloak.authenticated = true;
    
    try {
      const userProfile = await keycloak.loadUserProfile();
      const extractedTenantId = userProfile.attributes?.tenant_id 
        ? Array.isArray(userProfile.attributes.tenant_id) 
          ? userProfile.attributes.tenant_id[0] 
          : null 
        : null;

      localStorage.setItem("user_id", userProfile.username ?? "");
      localStorage.setItem("tenant_id", extractedTenantId ?? "");
    } catch (profileError) {
      console.error("Failed to load user profile:", profileError);
      // Continue anyway as we have the tokens
    }
    
    window.location.href = redirectUrl;
  } catch (err: any) {
    console.error("Email sign-in error:", err);
    
    // Handle network errors (can't reach server at all)
    if (err.name === 'TypeError' && err.message === 'Failed to fetch') {
      setError("Unable to connect to the server. Please check your internet connection and try again.");
    } 
    // Handle timeout errors
    else if (err.name === 'AbortError') {
      setError("Request timeout. Please check your connection and try again.");
    }
    // Use the error message from our try block
    else {
      setError(err.message || "An unexpected error occurred. Please try again.");
    }
    
    setIsLoading(false);
  }
};

  const handleSignUp = () => {
    window.location.href = "https://dapto.ai/pricing";
  };

  const validatePassword = (password: string): string | null => {
    if (password.length < 8) {
      return "Password must be at least 8 characters long";
    }
    if (!/[A-Z]/.test(password)) {
      return "Password must contain at least one uppercase letter";
    }
    if (!/[a-z]/.test(password)) {
      return "Password must contain at least one lowercase letter";
    }
    if (!/[0-9]/.test(password)) {
      return "Password must contain at least one number";
    }
    return null;
  };

  const handleResetPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    if (resetFormData.newPassword !== resetFormData.confirmPassword) {
      setError("New passwords do not match");
      setIsLoading(false);
      return;
    }

    const passwordError = validatePassword(resetFormData.newPassword);
    if (passwordError) {
      setError(passwordError);
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/reset-temp-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: resetFormData.username,
          temp_password: resetFormData.tempPassword,
          new_password: resetFormData.newPassword,
        }),
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.error || 'Failed to reset password');
      }

      localStorage.setItem('keycloakToken', data.access_token);
      localStorage.setItem('keycloakRefreshToken', data.refresh_token);

      keycloak.token = data.access_token;
      keycloak.refreshToken = data.refresh_token;
      keycloak.authenticated = true;

      const userProfile = await keycloak.loadUserProfile();
      const extractedTenantId = userProfile.attributes?.tenant_id
        ? Array.isArray(userProfile.attributes.tenant_id)
          ? userProfile.attributes.tenant_id[0]
          : null
        : null;

      localStorage.setItem("user_id", userProfile.username ?? "");
      localStorage.setItem("tenant_id", extractedTenantId ?? "");

      window.location.href = redirectUrl;
    } catch (err: any) {
      console.error("Password reset error:", err);
      setError(err.message || "Failed to reset password");
      setIsLoading(false);
    }
  };

  const handleForgotPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");
    setForgotSuccess("");

    if (forgotFormData.newPassword !== forgotFormData.confirmPassword) {
      setError("New passwords do not match");
      setIsLoading(false);
      return;
    }

    const passwordError = validatePassword(forgotFormData.newPassword);
    if (passwordError) {
      setError(passwordError);
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: forgotFormData.username,
          new_password: forgotFormData.newPassword,
          send_email: false,
        }),
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.error || 'Failed to reset password');
      }

      setForgotSuccess(data.message || 'Password reset successfully. You can now login with your new password.');
      setForgotFormData({
        username: "",
        newPassword: "",
        confirmPassword: "",
      });
      
      setTimeout(() => {
        setShowForgotModal(false);
        setForgotSuccess("");
        setError("");
      }, 3000);
    } catch (err: any) {
      console.error("Forgot password error:", err);
      setError(err.message || "Failed to reset password");
    } finally {
      setIsLoading(false);
    }
  };

  if (!initialized) {
    return (
      <div className="loading-container">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (initialized && keycloak.authenticated) {
    return <Navigate to={redirectUrl} replace />;
  }

  return (
    <div className="signin-container">
      <div className="signin-wrapper">
        <div className="signin-card">
          <div className="signin-header">
            <div className="logo-container">
              <div className="logo-box-login" />
              <Link to="/" style={{ display: "flex", alignItems: "center", gap: "10px", textDecoration: "none" }}>
                <img
                  src={logodapto}
                  alt="Dapto Logo"
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "6px",
                    objectFit: "cover",
                  }}
                />
                <span className="brand-name">DAPTO PRISM</span>
              </Link>
            </div>
            <h2 className="signin-title">Welcome Back</h2>
            <p className="signin-subtitle">Sign in to your account</p>
          </div>

          <div className="sso-buttons">
            <button
              className="sso-button sso-google"
              onClick={() => handleSSOLogin("google")}
              disabled={isLoading}
            >
              <svg className="sso-icon" viewBox="0 0 24 24">
                <path
                  fill="#4285F4"
                  d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                />
                <path
                  fill="#34A853"
                  d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                />
                <path
                  fill="#FBBC05"
                  d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                />
                <path
                  fill="#EA4335"
                  d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                />
              </svg>
              Sign in with Google
            </button>

            {/* <button
              className="sso-button sso-apple"
              onClick={() => handleSSOLogin("apple")}
              disabled={isLoading}
            >
              <svg className="sso-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
              </svg>
              Sign in with Apple
            </button>

            <button
              className="sso-button sso-microsoft"
              onClick={() => handleSSOLogin("microsoft")}
              disabled={isLoading}
            >
              <svg className="sso-icon" viewBox="0 0 24 24">
                <path fill="#f25022" d="M1 1h10v10H1z" />
                <path fill="#00a4ef" d="M13 1h10v10H13z" />
                <path fill="#7fba00" d="M1 13h10v10H1z" />
                <path fill="#ffb900" d="M13 13h10v10H13z" />
              </svg>
              Sign in with Microsoft
            </button> */}
          </div>

          <div className="divider">
            <div className="divider-line"></div>
            <div className="divider-text">
              <span>Or continue with email</span>
            </div>
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <form className="signin-form" onSubmit={handleEmailSignIn}>
            <div className="form-group">
              <input
                type="text"
                placeholder="Email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
                disabled={isLoading}
                className="form-input"
              />
            </div>
        <div className="form-group">
  <div className="password-input-wrapper">
    <input
      type={showPassword.login ? "text" : "password"}
      placeholder="Password"
      value={formData.password}
      onChange={(e) => setFormData({ ...formData, password: e.target.value })}
      required
      disabled={isLoading}
      className="form-input"
    />
    <button
      type="button"
      className="password-toggle-icon"
      onClick={() => setShowPassword({ ...showPassword, login: !showPassword.login })}
      disabled={isLoading}
    >
      {showPassword.login ? (
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
        </svg>
      ) : (
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
        </svg>
      )}
    </button>
  </div>
</div>

            <div style={{ textAlign: 'right', marginTop: '-0.5rem', marginBottom: '1rem' }}>
              <button
                type="button"
                onClick={() => {
                  setShowForgotModal(true);
                  setError("");
                }}
                className="signup-link"
                style={{ background: 'none', border: 'none', padding: 0, fontSize: '0.875rem' }}
              >
                Forgot Password?
              </button>
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="signin-button"
            >
              {isLoading ? "Signing in..." : "Sign In"}
            </button>
          </form>

          <div className="signin-footer">
            <p className="footer-text">
              Don't have an account?{" "}
              <button onClick={handleSignUp} className="signup-link">
                Sign Up
              </button>
            </p>
          </div>
        </div>
      </div>

      {showResetModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          padding: '1rem',
        }}>
          <div className="signin-card" style={{ maxWidth: '28rem', width: '100%', margin: 0 }}>
            <div className="signin-header">
              <h2 className="signin-title">Reset Temporary Password</h2>
              <p className="signin-subtitle">Please set a new password to continue</p>
            </div>

            {error && (
              <div className="error-message">
                {error}
              </div>
            )}

            <form className="signin-form" onSubmit={handleResetPassword}>
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Username"
                  value={resetFormData.username}
                  disabled
                  className="form-input"
                  style={{ opacity: 0.6 }}
                />
              </div>

             <div className="form-group">
  <div className="password-input-wrapper">
    <input
      type={showPassword.resetTemp ? "text" : "password"}
      placeholder="Temporary Password"
      value={resetFormData.tempPassword}
      onChange={(e) => setResetFormData({ ...resetFormData, tempPassword: e.target.value })}
      required
      disabled={isLoading}
      className="form-input"
    />
    <button
      type="button"
      className="password-toggle-icon"
      onClick={() => setShowPassword({ ...showPassword, resetTemp: !showPassword.resetTemp })}
      disabled={isLoading}
    >
      {showPassword.resetTemp ? (
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
        </svg>
      ) : (
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
        </svg>
      )}
    </button>
  </div>
</div>

             <div className="form-group">
  <div className="password-input-wrapper">
    <input
      type={showPassword.resetNew ? "text" : "password"}
      placeholder="New Password"
      value={resetFormData.newPassword}
      onChange={(e) => setResetFormData({ ...resetFormData, newPassword: e.target.value })}
      required
      disabled={isLoading}
      className="form-input"
      autoComplete="new-password"
    />
    <button
      type="button"
      className="password-toggle-icon"
      onClick={() => setShowPassword({ ...showPassword, resetNew: !showPassword.resetNew })}
      disabled={isLoading}
    >
      {showPassword.resetNew ? (
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
        </svg>
      ) : (
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
        </svg>
      )}
    </button>
  </div>
</div>

             <div className="form-group">
  <div className="password-input-wrapper">
    <input
      type={showPassword.resetConfirm ? "text" : "password"}
      placeholder="Confirm New Password"
      value={resetFormData.confirmPassword}
      onChange={(e) => setResetFormData({ ...resetFormData, confirmPassword: e.target.value })}
      required
      disabled={isLoading}
      className="form-input"
    />
    <button
      type="button"
      className="password-toggle-icon"
      onClick={() => setShowPassword({ ...showPassword, resetConfirm: !showPassword.resetConfirm })}
      disabled={isLoading}
    >
      {showPassword.resetConfirm ? (
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
        </svg>
      ) : (
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
        </svg>
      )}
    </button>
  </div>
</div>

              <div style={{ fontSize: '0.75rem', color: '#9CA3AF', marginTop: '-0.5rem', marginBottom: '1rem' }}>
                Password must be at least 8 characters with uppercase, lowercase, and numbers
              </div>

              <button
                type="submit"
                disabled={isLoading}
                className="signin-button"
              >
                {isLoading ? "Resetting Password..." : "Reset Password"}
              </button>

              <button
                type="button"
                onClick={() => {
                  setShowResetModal(false);
                  setError("");
                  setResetFormData({
                    username: "",
                    tempPassword: "",
                    newPassword: "",
                    confirmPassword: "",
                  });
                }}
                disabled={isLoading}
                style={{
                  width: '100%',
                  height: '3rem',
                  background: 'transparent',
                  color: '#9CA3AF',
                  border: '1px solid #4B5563',
                  borderRadius: '0.5rem',
                  fontWeight: 500,
                  marginTop: '0.5rem',
                  cursor: isLoading ? 'not-allowed' : 'pointer',
                  opacity: isLoading ? 0.5 : 1,
                }}
              >
                Cancel
              </button>
            </form>
          </div>
        </div>
      )}

      {showForgotModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          padding: '1rem',
        }}>
          <div className="signin-card" style={{ maxWidth: '28rem', width: '100%', margin: 0 }}>
            <div className="signin-header">
              <h2 className="signin-title">Forgot Password</h2>
              <p className="signin-subtitle">Enter your username and new password</p>
            </div>

            {error && (
              <div className="error-message">
                {error}
              </div>
            )}

            {forgotSuccess && (
              <div style={{
                marginBottom: '1rem',
                padding: '0.75rem',
                background: 'rgba(34, 197, 94, 0.1)',
                border: '1px solid rgba(34, 197, 94, 0.3)',
                borderRadius: '0.5rem',
                color: '#86EFAC',
                fontSize: '0.875rem',
              }}>
                {forgotSuccess}
              </div>
            )}

            <form className="signin-form" onSubmit={handleForgotPassword}>
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Username or Email"
                  value={forgotFormData.username}
                  onChange={(e) => setForgotFormData({ ...forgotFormData, username: e.target.value })}
                  required
                  disabled={isLoading}
                  className="form-input"
                />
              </div>

            <div className="form-group">
  <div className="password-input-wrapper">
    <input
      type={showPassword.forgotNew ? "text" : "password"}
      placeholder="New Password"
      value={forgotFormData.newPassword}
      onChange={(e) => setForgotFormData({ ...forgotFormData, newPassword: e.target.value })}
      required
      disabled={isLoading}
      className="form-input"
      autoComplete="new-password"
    />
    <button
      type="button"
      className="password-toggle-icon"
      onClick={() => setShowPassword({ ...showPassword, forgotNew: !showPassword.forgotNew })}
      disabled={isLoading}
    >
      {showPassword.forgotNew ? (
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
        </svg>
      ) : (
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
        </svg>
      )}
    </button>
  </div>
</div>

             <div className="form-group">
  <div className="password-input-wrapper">
    <input
      type={showPassword.forgotConfirm ? "text" : "password"}
      placeholder="Confirm New Password"
      value={forgotFormData.confirmPassword}
      onChange={(e) => setForgotFormData({ ...forgotFormData, confirmPassword: e.target.value })}
      required
      disabled={isLoading}
      className="form-input"
    />
    <button
      type="button"
      className="password-toggle-icon"
      onClick={() => setShowPassword({ ...showPassword, forgotConfirm: !showPassword.forgotConfirm })}
      disabled={isLoading}
    >
      {showPassword.forgotConfirm ? (
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
        </svg>
      ) : (
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
        </svg>
      )}
    </button>
  </div>
</div>

              <div style={{ fontSize: '0.75rem', color: '#9CA3AF', marginTop: '-0.5rem', marginBottom: '1rem' }}>
                Password must be at least 8 characters with uppercase, lowercase, and numbers
              </div>

              <button
                type="submit"
                disabled={isLoading}
                className="signin-button"
              >
                {isLoading ? "Resetting Password..." : "Reset Password"}
              </button>

              <button
                type="button"
                onClick={() => {
                  setShowForgotModal(false);
                  setError("");
                  setForgotSuccess("");
                  setForgotFormData({
                    username: "",
                    newPassword: "",
                    confirmPassword: "",
                  });
                }}
                disabled={isLoading}
                style={{
                  width: '100%',
                  height: '3rem',
                  background: 'transparent',
                  color: '#9CA3AF',
                  border: '1px solid #4B5563',
                  borderRadius: '0.5rem',
                  fontWeight: 500,
                  marginTop: '0.5rem',
                  cursor: isLoading ? 'not-allowed' : 'pointer',
                  opacity: isLoading ? 0.5 : 1,
                }}
              >
                Cancel
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;

// import React, { useState } from "react";
// import { useKeycloak } from "../../keycloakContext";
// import { Navigate, useLocation, Link } from "react-router-dom";
// import { loginWithSSO } from "../../services/keycloakAuth";
// import "./Login.css";
// import logodapto from "../../assets/images/logo-d.png";

// const Login = () => {
//   const { keycloak, initialized } = useKeycloak();
//   const location = useLocation();
//   const redirectUrl = location.state?.from || "/";

//   const [isLoading, setIsLoading] = useState(false);
//   const [formData, setFormData] = useState({ email: "", password: "" });
//   const [error, setError] = useState("");
  
//   // Temporarily disabled - backend issue
//   // const [showResetModal, setShowResetModal] = useState(false);
//   // const [resetFormData, setResetFormData] = useState({
//   //   username: "",
//   //   tempPassword: "",
//   //   newPassword: "",
//   //   confirmPassword: "",
//   // });
  
//   const [showForgotModal, setShowForgotModal] = useState(false);
//   const [forgotFormData, setForgotFormData] = useState({
//     username: "",
//     newPassword: "",
//     confirmPassword: "",
//   });
//   const [forgotSuccess, setForgotSuccess] = useState("");

//   const handleSSOLogin = async (provider: "google" | "apple" | "microsoft") => {
//     setIsLoading(true);
//     setError("");
//     try {
//       if (keycloak && initialized) {
//         await loginWithSSO(keycloak, provider, window.location.origin + redirectUrl);
//       }
//     } catch (err) {
//       console.error(`${provider} SSO login error:`, err);
//       setError(`Failed to sign in with ${provider}. Make sure ${provider} identity provider is configured in Keycloak.`);
//       setIsLoading(false);
//     }
//   };

//   const handleEmailSignIn = async (e: React.FormEvent) => {
//     e.preventDefault();
//     setIsLoading(true);
//     setError("");

//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/login`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           username: formData.email,
//           password: formData.password,
//         }),
//       });

//       let data;
//       try {
//         data = await response.json();
//       } catch (parseError) {
//         console.error('Failed to parse response:', parseError);
//         throw new Error('Unable to connect to the server. Please try again later.');
//       }

//       // console.log('Login response:', { status: response.status, data });

//       if (!response.ok) {
//         // Ignore temporary password errors from backend due to backend bug
//         // All 401 errors should show "Invalid credentials"
        
//         if (response.status === 401 || response.status === 403) {
//           throw new Error('Invalid email or password. Please try again.');
//         } else if (response.status === 404) {
//           throw new Error('User account not found.');
//         } else if (response.status >= 500) {
//           throw new Error('Server error. Please try again later.');
//         }
        
//         throw new Error('Invalid email or password. Please try again.');
//       }

//       const tokenResponse = data;
      
//       localStorage.setItem('keycloakToken', tokenResponse.access_token);
//       localStorage.setItem('keycloakRefreshToken', tokenResponse.refresh_token);
      
//       keycloak.token = tokenResponse.access_token;
//       keycloak.refreshToken = tokenResponse.refresh_token;
//       keycloak.authenticated = true;
      
//       const userProfile = await keycloak.loadUserProfile();
//       const extractedTenantId = userProfile.attributes?.tenant_id 
//         ? Array.isArray(userProfile.attributes.tenant_id) 
//           ? userProfile.attributes.tenant_id[0] 
//           : null 
//         : null;

//       localStorage.setItem("user_id", userProfile.username ?? "");
//       localStorage.setItem("tenant_id", extractedTenantId ?? "");
      
//       window.location.href = redirectUrl;
//     } catch (err: any) {
//       console.error("Email sign-in error:", err);
      
//       if (err.message === 'Failed to fetch' || err.name === 'TypeError') {
//         setError("Unable to connect to the server. Please check your internet connection and try again.");
//       } else {
//         setError(err.message || "Invalid email or password. Please try again.");
//       }
      
//       setIsLoading(false);
//     }
//   };

//   const handleSignUp = () => {
//     window.location.href = "https://dapto.ai/pricing";
//   };

//   const validatePassword = (password: string): string | null => {
//     if (password.length < 8) {
//       return "Password must be at least 8 characters long";
//     }
//     if (!/[A-Z]/.test(password)) {
//       return "Password must contain at least one uppercase letter";
//     }
//     if (!/[a-z]/.test(password)) {
//       return "Password must contain at least one lowercase letter";
//     }
//     if (!/[0-9]/.test(password)) {
//       return "Password must contain at least one number";
//     }
//     return null;
//   };

//   const handleForgotPassword = async (e: React.FormEvent) => {
//     e.preventDefault();
//     setIsLoading(true);
//     setError("");
//     setForgotSuccess("");

//     if (forgotFormData.newPassword !== forgotFormData.confirmPassword) {
//       setError("New passwords do not match");
//       setIsLoading(false);
//       return;
//     }

//     const passwordError = validatePassword(forgotFormData.newPassword);
//     if (passwordError) {
//       setError(passwordError);
//       setIsLoading(false);
//       return;
//     }

//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/forgot-password`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           username: forgotFormData.username,
//           new_password: forgotFormData.newPassword,
//           send_email: false,
//         }),
//       });

//       const data = await response.json();

//       if (!response.ok || !data.success) {
//         throw new Error(data.error || 'Failed to reset password');
//       }

//       setForgotSuccess(data.message || 'Password reset successfully. You can now login with your new password.');
//       setForgotFormData({
//         username: "",
//         newPassword: "",
//         confirmPassword: "",
//       });
      
//       setTimeout(() => {
//         setShowForgotModal(false);
//         setForgotSuccess("");
//         setError("");
//       }, 3000);
//     } catch (err: any) {
//       console.error("Forgot password error:", err);
//       setError(err.message || "Failed to reset password");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   if (!initialized) {
//     return (
//       <div className="loading-container">
//         <div className="spinner-border text-primary" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   if (keycloak.authenticated) {
//     return <Navigate to={redirectUrl} />;
//   }

//   return (
//     <div className="signin-container">
//       <div className="signin-wrapper">
//         <div className="signin-card">
//           <div className="signin-header">
//             <div className="logo-container">
//               <div className="logo-box-login" />
//               <Link to="/" style={{ display: "flex", alignItems: "center", gap: "10px", textDecoration: "none" }}>
//                 <img
//                   src={logodapto}
//                   alt="Dapto Logo"
//                   style={{
//                     width: "32px",
//                     height: "32px",
//                     borderRadius: "6px",
//                     objectFit: "cover",
//                   }}
//                 />
//                 <span className="brand-name">DAPTO PRISM</span>
//               </Link>
//             </div>
//             <h2 className="signin-title">Welcome Back</h2>
//             <p className="signin-subtitle">Sign in to your account</p>
//           </div>

//           <div className="sso-buttons">
//             <button
//               className="sso-button sso-google"
//               onClick={() => handleSSOLogin("google")}
//               disabled={isLoading}
//             >
//               <svg className="sso-icon" viewBox="0 0 24 24">
//                 <path
//                   fill="#4285F4"
//                   d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
//                 />
//                 <path
//                   fill="#34A853"
//                   d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
//                 />
//                 <path
//                   fill="#FBBC05"
//                   d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
//                 />
//                 <path
//                   fill="#EA4335"
//                   d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
//                 />
//               </svg>
//               Sign in with Google
//             </button>
//           </div>

//           <div className="divider">
//             <div className="divider-line"></div>
//             <div className="divider-text">
//               <span>Or continue with email</span>
//             </div>
//           </div>

//           {error && (
//             <div className="error-message">
//               {error}
//             </div>
//           )}

//           <form className="signin-form" onSubmit={handleEmailSignIn}>
//             <div className="form-group">
//               <input
//                 type="text"
//                 placeholder="Email"
//                 value={formData.email}
//                 onChange={(e) => setFormData({ ...formData, email: e.target.value })}
//                 required
//                 disabled={isLoading}
//                 className="form-input"
//               />
//             </div>
//             <div className="form-group">
//               <input
//                 type="password"
//                 placeholder="Password"
//                 value={formData.password}
//                 onChange={(e) => setFormData({ ...formData, password: e.target.value })}
//                 required
//                 disabled={isLoading}
//                 className="form-input"
//               />
//             </div>

//             <div style={{ textAlign: 'right', marginTop: '-0.5rem', marginBottom: '1rem' }}>
//               <button
//                 type="button"
//                 onClick={() => {
//                   setShowForgotModal(true);
//                   setError("");
//                 }}
//                 className="signup-link"
//                 style={{ background: 'none', border: 'none', padding: 0, fontSize: '0.875rem' }}
//               >
//                 Forgot Password?
//               </button>
//             </div>

//             <button
//               type="submit"
//               disabled={isLoading}
//               className="signin-button"
//             >
//               {isLoading ? "Signing in..." : "Sign In"}
//             </button>
//           </form>

//           <div className="signin-footer">
//             <p className="footer-text">
//               Don't have an account?{" "}
//               <button onClick={handleSignUp} className="signup-link">
//                 Sign Up
//               </button>
//             </p>
//           </div>
//         </div>
//       </div>

//       {showForgotModal && (
//         <div style={{
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           right: 0,
//           bottom: 0,
//           background: 'rgba(0, 0, 0, 0.7)',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           zIndex: 9999,
//           padding: '1rem',
//         }}>
//           <div className="signin-card" style={{ maxWidth: '28rem', width: '100%', margin: 0 }}>
//             <div className="signin-header">
//               <h2 className="signin-title">Forgot Password</h2>
//               <p className="signin-subtitle">Enter your username and new password</p>
//             </div>

//             {error && (
//               <div className="error-message">
//                 {error}
//               </div>
//             )}

//             {forgotSuccess && (
//               <div style={{
//                 marginBottom: '1rem',
//                 padding: '0.75rem',
//                 background: 'rgba(34, 197, 94, 0.1)',
//                 border: '1px solid rgba(34, 197, 94, 0.3)',
//                 borderRadius: '0.5rem',
//                 color: '#86EFAC',
//                 fontSize: '0.875rem',
//               }}>
//                 {forgotSuccess}
//               </div>
//             )}

//             <form className="signin-form" onSubmit={handleForgotPassword}>
//               <div className="form-group">
//                 <input
//                   type="text"
//                   placeholder="Username or Email"
//                   value={forgotFormData.username}
//                   onChange={(e) => setForgotFormData({ ...forgotFormData, username: e.target.value })}
//                   required
//                   disabled={isLoading}
//                   className="form-input"
//                 />
//               </div>

//               <div className="form-group">
//                 <input
//                   type="password"
//                   placeholder="New Password"
//                   value={forgotFormData.newPassword}
//                   onChange={(e) => setForgotFormData({ ...forgotFormData, newPassword: e.target.value })}
//                   required
//                   disabled={isLoading}
//                   className="form-input"
//                   autoComplete="new-password"
//                 />
//               </div>

//               <div className="form-group">
//                 <input
//                   type="password"
//                   placeholder="Confirm New Password"
//                   value={forgotFormData.confirmPassword}
//                   onChange={(e) => setForgotFormData({ ...forgotFormData, confirmPassword: e.target.value })}
//                   required
//                   disabled={isLoading}
//                   className="form-input"
//                 />
//               </div>

//               <div style={{ fontSize: '0.75rem', color: '#9CA3AF', marginTop: '-0.5rem', marginBottom: '1rem' }}>
//                 Password must be at least 8 characters with uppercase, lowercase, and numbers
//               </div>

//               <button
//                 type="submit"
//                 disabled={isLoading}
//                 className="signin-button"
//               >
//                 {isLoading ? "Resetting Password..." : "Reset Password"}
//               </button>

//               <button
//                 type="button"
//                 onClick={() => {
//                   setShowForgotModal(false);
//                   setError("");
//                   setForgotSuccess("");
//                   setForgotFormData({
//                     username: "",
//                     newPassword: "",
//                     confirmPassword: "",
//                   });
//                 }}
//                 disabled={isLoading}
//                 style={{
//                   width: '100%',
//                   height: '3rem',
//                   background: 'transparent',
//                   color: '#9CA3AF',
//                   border: '1px solid #4B5563',
//                   borderRadius: '0.5rem',
//                   fontWeight: 500,
//                   marginTop: '0.5rem',
//                   cursor: isLoading ? 'not-allowed' : 'pointer',
//                   opacity: isLoading ? 0.5 : 1,
//                 }}
//               >
//                 Cancel
//               </button>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Login;